//@author: mandy
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { DropdownApi } from "../dropdown.api";

@TypeManagerDecorator("s25-ng-folder-type-dropdown")
@Component({
    selector: "s25-ng-folder-type-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [value]="value()"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [apiBean]="apiBean"
                [placeholder]="''"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                (valueChange)="onValueChange($event)"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25FolderTypeDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() items: any;
    constructor(private elementRef: ElementRef) {
        super();
    }

    ngOnInit() {
        this.cd.detectChanges();
    }

    refresh = (items: any[]) => {
        this.items = items;
        DropdownApi.refresh(this.elementRef.nativeElement, this.items);
        this.cd.detectChanges();
    };
}
